export const ai = {
  en: {
    providersTitle: "Language providers",
    providersNote: "Where the assistant sends its requests. Keys are stored encrypted and never returned.",
    noProviders: "No provider configured. The assistant cannot answer until one is added and enabled.",
    providerName: "Name",
    providerEndpoint: "Endpoint",
    providerModelField: "Model",
    providerEnabledLabel: "Enabled",
    providerDisabledLabel: "Disabled",
    providerKey: "API key",
    providerEnabled: "Use this provider",
    keyStored: "Stored",
    keyMissing: "Missing",
    keyUnreadable: "Unreadable",
    keyRequired: "Required for a new provider.",
    keyKeep: "Leave blank to keep the stored key.",
    intro: "Ask about your organisation. The assistant can only see what your role already lets you see, and it never changes anything without your approval.",
    placeholder: "Ask a question…",
    askButton: "Ask",
    thinking: "Working…",
    nothingYet: "Ask a question, or pick one of the options above.",
    notSure: "I am not sure what you mean",
    notSureHelp: "Rather than guess, here is what I can do for you:",
    notEnabledForYou: "The AI Assistant has not been enabled for you.",
    providerBuiltin: "Built-in",
    providerModel: "Language model",
    severity_ok: "All clear",
    severity_info: "For information",
    severity_warning: "Needs attention",

    skillHeadcountTitle: "Headcount",
    skillHeadcountDescription: "How many people work here, by branch.",
    skillWhoIsAwayTitle: "Who is away",
    skillWhoIsAwayDescription: "Who is on approved leave today.",
    skillMyLeaveTitle: "My leave balance",
    skillMyLeaveDescription: "How many days you have left.",
    skillExpiringContractsTitle: "Expiring contracts",
    skillExpiringContractsDescription: "Fixed-term contracts ending soon.",
    skillAttendanceAnomaliesTitle: "Attendance problems",
    skillAttendanceAnomaliesDescription: "Absences, lateness and missing check-outs.",
    skillLeaveLiabilityTitle: "Leave liability",
    skillLeaveLiabilityDescription: "Untaken leave the clinic owes.",
    skillPayrollReadinessTitle: "Payroll readiness",
    skillPayrollReadinessDescription: "Whether this month's payroll is ready.",
    skillMissingManagersTitle: "Missing managers",
    skillMissingManagersDescription: "People with no manager recorded.",
    skillBriefingTitle: "What needs my attention",
    skillBriefingDescription: "Everything worth knowing, in one place.",
    skillNotifyExpiringTitle: "Remind about expiring contracts",
    skillNotifyExpiringDescription: "Prepare a reminder for staff whose contract ends soon.",

    findingHeadcount: "{count} people",
    findingWhoIsAway: "{count} away today",
    findingNobodyAway: "Nobody is on leave today",
    findingMyLeave: "Your leave balances",
    findingExpiringContracts: "{count} contracts end within {days} days",
    findingNoExpiringContracts: "No contracts end in the next {days} days",
    findingAnomalies: "{count} people with attendance to look at",
    findingNoAnomalies: "No attendance problems in the last {days} days",
    findingLeaveLiability: "{days} days of untaken leave outstanding",
    findingPayrollReady: "Payroll for {month}/{year} is approved",
    findingPayrollDrafts: "{count} payroll runs still in draft",
    findingPayrollNotStarted: "Payroll for {month}/{year} has not been generated",
    findingMissingManagers: "{count} people have no manager recorded",
    findingNoMissingManagers: "Everyone has a manager recorded",
    findingProposalPrepared: "Prepared a reminder for {count} people",

    proposalTitle: "Prepared action",
    proposalNothingYet: "Nothing has happened yet. This will only run if you approve it.",
    proposalAffects: "Affects {count} people",
    proposalExpires: "Expires at {time}",
    proposalApprove: "Approve and run",
    proposalReject: "Discard",
    proposalTypeToConfirm: "Type the action name to confirm",

    settingsTitle: "AI Assistant",
    enableModule: "Enable the AI Assistant for this organisation",
    enableDescription: "Off by default. Nobody has an assistant until you switch this on and grant access individually.",
    rbacNote: "AI access is separate from role permissions. Granting a capability never widens what somebody can see — the assistant can only read what that person could already open themselves.",
    whoHasAccess: "Who has access",
    nobodyGranted: "Nobody has been granted access yet.",
    grantAccessTo: "Grant access to",
    chooseEmployee: "Choose an employee…",
    revoke: "Revoke",
    suspended: "Suspended",
    capAsk: "Ask",
    capAnalyse: "Analyse",
    capSuggest: "Suggest",
    capDocuments: "Documents",
    capReports: "Reports",
    capExecute: "Execute",
    showTrail: "Show the interaction trail",
    hideTrail: "Hide the interaction trail",
    trailWhen: "When",
    trailWho: "Who",
    trailCapability: "Capability",
    trailAsked: "Asked",
    trailOutcome: "Outcome",
  },
  ar: {
    providersTitle: "مزودو النماذج اللغوية",
    providersNote: "الجهة التي يرسل إليها المساعد طلباته. تُخزَّن المفاتيح مشفّرة ولا تُعاد أبداً.",
    noProviders: "لا يوجد مزود مهيأ. لن يتمكن المساعد من الإجابة حتى تتم إضافة مزود وتفعيله.",
    providerName: "الاسم",
    providerEndpoint: "العنوان",
    providerModelField: "النموذج",
    providerEnabledLabel: "مفعّل",
    providerDisabledLabel: "معطّل",
    providerKey: "مفتاح الواجهة",
    providerEnabled: "استخدام هذا المزود",
    keyStored: "مخزَّن",
    keyMissing: "غير موجود",
    keyUnreadable: "غير قابل للقراءة",
    keyRequired: "مطلوب عند إضافة مزود جديد.",
    keyKeep: "اتركه فارغاً للإبقاء على المفتاح المخزَّن.",
    intro: "اسأل عن منشأتك. لا يرى المساعد إلا ما تسمح به صلاحياتك، ولا يغيّر شيئاً دون موافقتك.",
    placeholder: "اطرح سؤالاً…",
    askButton: "اسأل",
    thinking: "جارٍ العمل…",
    nothingYet: "اطرح سؤالاً أو اختر أحد الخيارات أعلاه.",
    notSure: "لم أفهم المقصود",
    notSureHelp: "بدلاً من التخمين، هذا ما يمكنني تقديمه:",
    notEnabledForYou: "لم يتم تفعيل المساعد الذكي لحسابك.",
    providerBuiltin: "المحرك المدمج",
    providerModel: "نموذج لغوي",
    severity_ok: "لا ملاحظات",
    severity_info: "للعلم",
    severity_warning: "يستدعي الانتباه",

    skillHeadcountTitle: "عدد الموظفين",
    skillHeadcountDescription: "عدد العاملين حسب الفرع.",
    skillWhoIsAwayTitle: "من في إجازة",
    skillWhoIsAwayDescription: "من هم في إجازة معتمدة اليوم.",
    skillMyLeaveTitle: "رصيد إجازاتي",
    skillMyLeaveDescription: "الأيام المتبقية لك.",
    skillExpiringContractsTitle: "العقود المنتهية",
    skillExpiringContractsDescription: "العقود محددة المدة التي تنتهي قريباً.",
    skillAttendanceAnomaliesTitle: "ملاحظات الحضور",
    skillAttendanceAnomaliesDescription: "الغياب والتأخير وعدم تسجيل الانصراف.",
    skillLeaveLiabilityTitle: "التزامات الإجازات",
    skillLeaveLiabilityDescription: "الإجازات غير المستخدمة المستحقة على المنشأة.",
    skillPayrollReadinessTitle: "جاهزية الرواتب",
    skillPayrollReadinessDescription: "هل رواتب هذا الشهر جاهزة.",
    skillMissingManagersTitle: "مدراء غير محددين",
    skillMissingManagersDescription: "موظفون بلا مدير مباشر مسجل.",
    skillBriefingTitle: "ما يحتاج انتباهي",
    skillBriefingDescription: "كل ما يستحق المعرفة في مكان واحد.",
    skillNotifyExpiringTitle: "تذكير بالعقود المنتهية",
    skillNotifyExpiringDescription: "تجهيز تذكير للموظفين الذين تنتهي عقودهم قريباً.",

    findingHeadcount: "{count} موظف",
    findingWhoIsAway: "{count} في إجازة اليوم",
    findingNobodyAway: "لا يوجد أحد في إجازة اليوم",
    findingMyLeave: "أرصدة إجازاتك",
    findingExpiringContracts: "{count} عقد ينتهي خلال {days} يوم",
    findingNoExpiringContracts: "لا توجد عقود تنتهي خلال {days} يوم",
    findingAnomalies: "{count} موظف لديهم ملاحظات حضور",
    findingNoAnomalies: "لا ملاحظات حضور خلال {days} يوم الماضية",
    findingLeaveLiability: "{days} يوم إجازة غير مستخدمة مستحقة",
    findingPayrollReady: "رواتب {month}/{year} معتمدة",
    findingPayrollDrafts: "{count} مسيّر رواتب ما زال مسودة",
    findingPayrollNotStarted: "لم يتم إنشاء رواتب {month}/{year}",
    findingMissingManagers: "{count} موظف بلا مدير مباشر مسجل",
    findingNoMissingManagers: "جميع الموظفين لديهم مدير مباشر مسجل",
    findingProposalPrepared: "تم تجهيز تذكير لـ {count} موظف",

    proposalTitle: "إجراء مُجهّز",
    proposalNothingYet: "لم يحدث شيء بعد. لن يُنفّذ هذا إلا بموافقتك.",
    proposalAffects: "يشمل {count} موظف",
    proposalExpires: "ينتهي في {time}",
    proposalApprove: "الموافقة والتنفيذ",
    proposalReject: "تجاهل",
    proposalTypeToConfirm: "اكتب اسم الإجراء للتأكيد",

    settingsTitle: "المساعد الذكي",
    enableModule: "تفعيل المساعد الذكي في هذه المنشأة",
    enableDescription: "معطّل افتراضياً. لا يحصل أحد على مساعد حتى تُفعّله وتمنح الصلاحية فردياً.",
    rbacNote: "صلاحية استخدام المساعد منفصلة عن صلاحيات الدور. منح قدرة لا يوسّع ما يمكن للشخص رؤيته — فالمساعد لا يقرأ إلا ما يستطيع ذلك الشخص فتحه بنفسه.",
    whoHasAccess: "من لديه صلاحية",
    nobodyGranted: "لم تُمنح الصلاحية لأحد بعد.",
    grantAccessTo: "منح الصلاحية لـ",
    chooseEmployee: "اختر موظفاً…",
    revoke: "إلغاء",
    suspended: "معلّق",
    capAsk: "السؤال",
    capAnalyse: "التحليل",
    capSuggest: "الاقتراح",
    capDocuments: "المستندات",
    capReports: "التقارير",
    capExecute: "التنفيذ",
    showTrail: "إظهار سجل التفاعلات",
    hideTrail: "إخفاء سجل التفاعلات",
    trailWhen: "الوقت",
    trailWho: "المستخدم",
    trailCapability: "القدرة",
    trailAsked: "السؤال",
    trailOutcome: "النتيجة",
  },
} as const;
